const hasError = (errors = {}) =>
  Object.values(errors).some((error) => !!error);

export default hasError;
